export default "__VITE_ASSET__fb06b14d__"